import { render } from "./ExclusiveBrandSectionThreeCMS.vue?vue&type=template&id=322e2f42"
import script from "../js/exclusive-brand-section-three-cms.js?vue&type=script&lang=js"
export * from "../js/exclusive-brand-section-three-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__